import { createSlice } from "@reduxjs/toolkit"
import { ApiStatus } from "../../types/api/status"
import { IntakeCart, intakeCartType } from "../../types/slices/intakeCartType"
import { RootState } from "../store"

const initialState: intakeCartType = {
    status: ApiStatus.FETCHED,
    intakeCarts: [],
    intakeCartSelected: {} as IntakeCart,
    errorMessage: undefined
}

const intakeCartSlice = createSlice({
    name: 'intakeCartSlice',
    initialState,
    reducers: {
        onFetchIntakeCarts(state, { payload }: { payload: IntakeCart[] }) {
            state.status = ApiStatus.FETCHED
            state.intakeCarts = payload
            state.errorMessage = undefined
        },
        onSetSelectedIntakeCart(state, { payload }: { payload: IntakeCart }) {
            state.intakeCartSelected = payload
        },
        changeStatus(state, { payload }: { payload: ApiStatus }) {
            state.status = payload
        }
    }
})

export const selectIntakeCartState = (state: RootState) => state.intakeCartSlice
export default intakeCartSlice.reducer
export const {
    onFetchIntakeCarts,
    onSetSelectedIntakeCart,
    changeStatus
} = intakeCartSlice.actions